import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// IMPORTANTE: Importar el interceptor ANTES que cualquier servicio
import "./services/fetchInterceptor";

// Importaciones existentes
import { AuthProvider, useAuth } from "./services/AuthContext";
import MainLayout from "./layouts/MainLayout";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ServicePage from "./pages/ServicePage";
import SectionPage from "./pages/SectionPage";
import ProtectedRoute from "./components/ProtectedRoute";
import QuienesSomosPage from "./pages/QuienesSomosPage";
import ScrollToTop from "./components/ScrollToTop";
import SessionExpired from "./components/SessionExpired";

// IMPORTACIONES PARA ADMINISTRACIÓN
import AdminDashboard from "./pages/AdminDashboard";
import AdminServiceEdit from "./pages/AdminServiceEdit";
import AdminServiceSections from "./pages/AdminServiceSections";
import AdminSubsections from "./pages/AdminSubsections";
import AdminServiceCreate from "./pages/AdminServiceCreate";

function AppContent() {
  const { isSessionExpiring } = useAuth();

  return (
    <>
      {isSessionExpiring && <SessionExpired />}
      <Router>
        <ScrollToTop />

        <Routes>
          {/* Rutas públicas */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* RUTAS DE ADMINISTRACIÓN */}

          {/* Dashboard principal */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AdminDashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Editar servicio */}
          <Route
            path="/admin/servicios/:id/editar"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AdminServiceEdit />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Crear servicio */}
          <Route
            path="/admin/servicios/nuevo"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AdminServiceCreate />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Gestionar secciones de un servicio */}
          <Route
            path="/admin/servicios/:id/secciones"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AdminServiceSections />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Gestionar subsecciones de una sección */}
          <Route
            path="/admin/servicios/:serviceId/secciones/:sectionId/subsecciones"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <AdminSubsections />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          {/* Redirección de dashboard legacy */}
          <Route path="/dashboard" element={<Navigate to="/admin" replace />} />

          {/* RUTAS PÚBLICAS */}
          <Route
            path="/servicios/:id"
            element={
              <MainLayout>
                <ServicePage />
              </MainLayout>
            }
          />

          <Route
            path="/servicios/:serviceId/secciones/:sectionId"
            element={
              <MainLayout>
                <SectionPage />
              </MainLayout>
            }
          />

          <Route
            path="/quienes-somos"
            element={
              <MainLayout>
                <QuienesSomosPage />
              </MainLayout>
            }
          />

          {/* Ruta principal */}
          <Route
            path="/"
            element={
              <MainLayout>
                <QuienesSomosPage />
              </MainLayout>
            }
          />

          {/* Rutas no encontradas */}
          <Route path="*" element={<Navigate to="/quienes-somos" replace />} />
        </Routes>
      </Router>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
